module.exports = __webpack_public_path__ + "img/bowls-dark.93a2dca2.svg";